"use client";

import { PageWithSubSidebar, SubSidebarToggle } from "@/components/sub-sidebar";
import { NavigationConfig } from "@/config/navigation-config";
import { usePathname } from "next/navigation";

export default function SettingsLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const settingsNavItems = NavigationConfig.getGroups("settings");
  const currentPage = settingsNavItems.find((item) => item.href === pathname);

  return (
    <PageWithSubSidebar subNavigation={settingsNavItems}>
      <div className="dark:bg-background h-full w-full bg-white px-6 py-8">
        {currentPage && (
          <div className="mb-9 flex items-center gap-3">
            <SubSidebarToggle className="md:hidden" />
            <h1 className="text-2xl font-bold">{currentPage.title}</h1>
          </div>
        )}

        {children}
      </div>
    </PageWithSubSidebar>
  );
}
